(function () {
  function bindQty(wrap) {
    if (!wrap || wrap.dataset.edBound) return;
    wrap.dataset.edBound = '1';
    var input = wrap.querySelector('.ed-usf-qty__input');
    var down = wrap.querySelector('[data-ed-qty-down]');
    var up = wrap.querySelector('[data-ed-qty-up]');
    if (!input) return;
    var moq = Math.max(1, parseInt(wrap.getAttribute('data-moq'), 10) || parseInt(input.min, 10) || 1);
    function snap(v) {
      var n = parseInt(v, 10);
      if (isNaN(n) || n < moq) return moq;
      return Math.round(n / moq) * moq || moq;
    }
    function sync() {
      input.value = String(snap(input.value));
      if (down) down.disabled = parseInt(input.value, 10) <= moq;
    }
    if (down) {
      down.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = String(Math.max(moq, snap(input.value) - moq));
        sync();
      });
    }
    if (up) {
      up.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = String(snap(input.value) + moq);
        sync();
      });
    }
    input.addEventListener('change', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('[data-ed-card-qty]').forEach(bindQty);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
